module.exports = __webpack_public_path__ + "static/media/Chelmsford Rd, Hillsborough, CA2.422e71e8.jpg";